import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { PropTypes } from 'prop-types';
import { observer } from 'mobx-react';

import { LANG_AVAILABLE } from 'common/consts/language-code';
import LanguageService from 'services/Language.service';
import GlobalMetaTagsStore from 'stores/GlobalMetaTags.store';

@observer
export default class InjectMetaTags extends Component {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    ogImage: PropTypes.string,
    ogType: PropTypes.string,
    noIndex: PropTypes.string,
    isHomePage: PropTypes.bool
  };

  static defaultProps = {
    title: '',
    description: '',
    ogImage: '',
    ogType: '',
    noIndex: '',
    isHomePage: false
  };

  componentDidMount() {
    const { getMetaTagsData } = GlobalMetaTagsStore;
    getMetaTagsData();
  }

  renderHreflangs = () => {
    const { isHomePage } = this.props;

    if (isHomePage) {
      return LANG_AVAILABLE.map((language, i) => {
        return (
          <link
            key={i}
            rel="alternate"
            hreflang={language}
            href={`${document.location.origin}/${
              !LanguageService.isDefault(language) ? language : ''
            }`}
          />
        );
      });
    }

    const currentLanguage = LanguageService.getLang();

    return (
      <link
        rel="alternate"
        hreflang={currentLanguage}
        href={document.location.href}
      />
    );
  };

  renderGlobalMetaTags() {
    const { metaTags } = GlobalMetaTagsStore;
    return metaTags
      ? metaTags.metaTags.map(({ system, name, content }) => (
          <meta key={system.id} name={name} content={content} />
        ))
      : null;
  }

  render() {
    const {
      props: { title, description, ogImage, ogType, noIndex, canonicalArticle }
    } = this;

    return (
      <Helmet defaultTitle="TenderHut" titleTemplate="%s - TenderHut">
        {title && <title>{title}</title>}
        {description && <meta name="description" content={description} />}
        {title && <meta property="og:title" content={title} />}
        {ogType && <meta property="og:type" content={ogType} />}
        {ogImage && <meta property="og:image" content={ogImage} />}
        {description && (
          <meta property="og:description" content={description} />
        )}
        <meta name="twitter:card" content="summary" />
        {noIndex && <meta name="robots" content={noIndex} />}
        {canonicalArticle && <link rel="canonical" href={canonicalArticle} />}
        {this.renderHreflangs()}
        {this.renderGlobalMetaTags()}
      </Helmet>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/InjectMetaTags/InjectMetaTags.js